import API_BASE_URL from "../../../../../Constants";

export const fetchSalesPersonData = async (setSalesPersonData) => {
    const url = `${API_BASE_URL}/api/setup/salesperson/salespersons`;

    try {
        const response = await fetch(url);
        const data = await response.json();


        setSalesPersonData(data);
    } catch (err) {
        console.error('Error fetching salespersons: ', err);
    }
};

export const fetchContacts = async (setContactsData) => {
    const url = `${API_BASE_URL}/api/setup/contacts/get-all`;


    try {
        const response = await fetch(url);
        const data = await response.json();

        setContactsData(data);
        return data;
    } catch (err) {
        console.error('Error fetching contacts: ', err);
        return [];
    }

}

export const fetchProposalsSubClasses = async (API_BASE_URL, setProposalsSubclassesData, setProposalsData, getProposalClassesFromSubClasses) => {
    const url = `${API_BASE_URL}/api/proposals-and-jobs/subclasses`;

    try {
        const response = await fetch(url);
        const data = await response.json();
        setProposalsSubclassesData(data);

        setProposalsData(getProposalClassesFromSubClasses(data));
    } catch (err) {
        console.error('Error fetching proposals: ', err);
    }
};

export const addProposal = async (API_BASE_URL, formData) => {
    let wizardPropData = {
        proposal: transformProposalData(formData),
        phasePerDevice: formData.phasePerDevice,
        devices: formData.selectedItems,
    }

    const url = `${API_BASE_URL}/api/proposals-and-jobs/proposals`;
    const options = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(wizardPropData),
    };

    try {
        const response = await fetch(url, options);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return await response.json();
    } catch (err) {
        throw new Error(`Error adding proposal: ${err}`);
    }

}

export const getProposalClassesFromSubClasses = (subClasses) => {


    if (!Array.isArray(subClasses)) {
        console.error('subClasses is not an array');
        return [];
    }

    const uniqueClasses = new Map();

    subClasses.forEach(subClass => {
        const { classId, className } = subClass.proposalClass;
        if (!uniqueClasses.has(classId)) {
            uniqueClasses.set(classId, { classId, className });
        }
    });

    return Array.from(uniqueClasses.values());
};

export const fetchBuildingDevices = async (buildingId) => {
    const url = `${API_BASE_URL}/api/setup/buildings/devices/${buildingId}`;
    const options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    };
    try {
        const response = await fetch(url, options);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data;

    } catch (err) {
        console.error('Error fetching building devices: ', err);
        return [];
    }
}

export const transformProposalData = (inputData) => {
    return {
        proposalNumber: inputData.proposalNumber ?? null,
        salesPerson: inputData.salesPerson ?? null,
        building: inputData.building ?? null,
        proposalStatus: "New", // Default constant option ("New" or "Accepted")
        daysValid: Math.max(0, parseInt(inputData.numberOfDaysValid) || 0), // Ensure non-negative

        // Ensure dates are formatted correctly and not in the past
        submitDate: inputData.submitDate ?? new Date().toISOString(),
        startDate: inputData.startDate ?? null, // Default to 30 days later

        proposalSubClass: {
            subClassId: inputData.proposalSubclass?.subClassId ?? null,
            subClassName: inputData.proposalSubclass?.subClassName ?? "",
            proposalClass: {
                classId: inputData.proposalSubclass?.proposalClass?.classId ?? null,
                className: inputData.proposalSubclass?.proposalClass?.className ?? ""
            }
        },

        description: inputData.description ?? "",
        calculationType: inputData.calculationType ?? "Price By Phase", // Default value
        isTaxable: false, // Default to false
        numOfInstallments: parseInt(inputData.numberOfInstallments) || 0, // Ensure numeric
        installmentType: inputData.installmentType ?? "Use Currency Amounts", // Default

        taxExemptNumber: parseInt(inputData.taxExemptNumber) || null,

        approvalDate: inputData.approvalDate ?? null,
        approvedBy: null,

        expirationDate: inputData.expirationDate ?? null,
        cancellationDate: null,
        cancelledBy: null,

        contact: inputData.contact ?? null,
    };
};